module.exports = __webpack_public_path__ + "static/visionar_augemented_reality_5_creative_marketing-_ideas-30d967e135993bd3a30498baaa3734f8.jpg";